import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import OfferSection from "@/components/landing/OfferSection";
import WhyChoose from "@/components/landing/WhyChoose";
import Gallery from "@/components/landing/Gallery";
import LocationSection from "@/components/landing/LocationSection";
import Reviews from "@/components/landing/Reviews";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import StickyMobileCta from "@/components/landing/StickyMobileCta";
import Footer from "@/components/landing/Footer";

export default function App() {
  return (
    <div className="min-h-screen bg-[#FAF8F5] font-sans text-[#1C1917] antialiased">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <Services />
        <OfferSection />
        <WhyChoose />
        <Gallery />
        <LocationSection />
        <Reviews />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyMobileCta />
    </div>
  );
}
